import { render } from "./Workorder_CXFQ.vue?vue&type=template&id=748b5845&scoped=true"
import script from "./Workorder_CXFQ.vue?vue&type=script&lang=js"
export * from "./Workorder_CXFQ.vue?vue&type=script&lang=js"

import "./Workorder_CXFQ.vue?vue&type=style&index=0&id=748b5845&scoped=true&lang=less"

import exportComponent from "E:\\IdeaProjects\\jgwgxt-qt\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-748b5845"]])

export default __exports__